import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.LeaseAdminFeeAmount, LocationVarKey.CostAdminFee1, LocationVarKey.CostAdminFee2];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Admin Fee
      </PageHeader>

      <InputRow {...page} keyName={LocationVarKey.LeaseAdminFeeAmount} label="Admin Fee Amount" />
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.CostAdminFee1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.CostAdminFee2}
        enableSwitchVar={LocationVarKey.CostAdminFee2Enabled}
      />
    </>
  );
}
